import { SortDescriptor } from '@progress/kendo-data-query'
import { WalletFilterKey, WalletKey } from 'api/Wallet/Types/Wallet'

export const normalizeWalletsSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === WalletKey.name) {
        return { ...x, field: WalletFilterKey.name }
      }
      if (x.field === WalletKey.client) {
        return { ...x, field: WalletFilterKey.client }
      }
      if (x.field === WalletKey.client) {
        return { ...x, field: WalletFilterKey.client }
      }
      if (x.field === WalletKey.walletType) {
        return { ...x, field: WalletFilterKey.walletType }
      }
      if (x.field === WalletKey.walletState) {
        return { ...x, field: WalletFilterKey.walletState }
      }
      if (x.field === WalletKey.currency) {
        return { ...x, field: WalletFilterKey.currency }
      }
      if (x.field === WalletKey.reserved) {
        return { ...x, field: WalletFilterKey.reserved }
      }
      if (x.field === WalletKey.balance) {
        return { ...x, field: WalletFilterKey.balance }
      }
      if (x.field === WalletKey.createdDate) {
        return { ...x, field: WalletFilterKey.createdDate }
      }
      if (x.field === WalletKey.companyName) {
        return { ...x, field: WalletFilterKey.company }
      }

      return x
    })
    .filter((x) => !!x)
